import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WholeNumbersDirective } from './whole-numbers.directive';

@NgModule({
  declarations: [WholeNumbersDirective],
  imports: [CommonModule],
  exports: [WholeNumbersDirective],
})
export class WholeNumbersModule {}
